import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { toast } from "react-toastify";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const PayoutDetails = ({
  payoutDetailsWithId,
  match,
  getAllThePayoutDetailsWithId = [],
  documentUrlDataPublic,
  documentUploadUrlPublic,
  updateAllPayoutDetails,
}) => {
  const [inputList, setInputList] = useState([{
    modification_payout_amount: "",
    modification_payout_percentage: ""
  }]);
  const [isLoading, setIsLoading] = useState(false);
  const [modificationRow, setModificationRow] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      await payoutDetailsWithId(match?.params?.id);
    })();
    setIsLoading(false);
  }, [match?.params?.id, payoutDetailsWithId]);

  const handleModify = () => {
    setModificationRow(true);
  };

  const handleModalHide = () => setIsModal(false);

  const handleChange = (value, field) => {
    let list = [...inputList];
    list[0][field] = value;
    setInputList(list);
  };

  const handleFileUpload = (val) => {
    setInputList((prev) => {
      const updatedList = [...prev];
      updatedList[0].upload_approval_document = val;
      return updatedList;
    });
  };

  const handleAccept = async () => {
    const inputData = [
      {
        ...inputList[0],
        action: "accept",
        loan_application_id: parseInt(match?.params?.id),
        modification_payout_amount: getAllThePayoutDetailsWithId?.final_payout_amount,
        modification_payout_percentage: getAllThePayoutDetailsWithId?.final_payout_percentage,
      },
    ];
  
    setIsLoading(true);
    const res = await updateAllPayoutDetails(inputData);
    if (res.status === true) {
      setIsModal(true);
    }
    setIsLoading(false);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    inputList[0]['loan_application_id'] = match?.params?.id;
    inputList[0]['action'] = "modify";
  
    console.log("Submitted Input List:", inputList);
  
    setIsLoading(true);
    const res = await updateAllPayoutDetails(inputList);
    if (res.status === true) {
      setIsModal(true);
    } else {
      toast.error("Failed to performed action!");
    }
    setIsLoading(false);
  };

  const handleConfirmation = (e) => {
    if(window.confirm("Are you want to submit?") === true){
      handleSubmit(e);
    }
  }
  return (
      // <Layout title={"Payout Details"} isGoback isLoading={isLoading}>
      //   <div className="container-fluid">
      //     <div className="card">
      //       <div className="card-header">{"Payout Amount"}</div>
      //       <div className="card-body">
      //         <div className="">
      //           <div className="cl-md-12">
      //             <ConstantInput
      //                 label={"Amount"}
      //                 handleChange={(val) =>{
      //                   handleChange(val, 'modification_payout_amount')
      //                 }}
      //                 // disabled={true}
      //                 type="number"
      //                 step={'any'}
      //                 decimal={'decimal'}
      //             />
      //           </div>
      //           <div className="col-md-12 mb-2">
      //             <center>
      //               <Button onClick={(e) => {handleConfirmation(e)}}>
      //                 Submit
      //               </Button>
      //             </center>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </Layout>
//
  <Layout title={"Payout Details"} isGoback isLoading={isLoading}>
      {getAllThePayoutDetailsWithId?.track?.length > 0 ? (
          <Fragment>
            <div className="panel-card">
              <div className="panel-heading">Payout Details</div>
            <div className="panel-body">
              <div className="details-listing mb-5">
                <table className="table table-bordered mr-4">
                  <tbody>
                    {(() => {
                      const defaultGeneratedItem =
                        getAllThePayoutDetailsWithId.track.find(
                          (trackItem) =>
                            trackItem.status === "DEFAULT_GENERATED"
                        );
                      const modifiedByDSMItem =
                        getAllThePayoutDetailsWithId.track.find(
                          (trackItem) => trackItem.status === "MODIFIED_BY_DSM"
                        );
                      const modifiedByCentralOpsItem =
                        getAllThePayoutDetailsWithId.track.find(
                          (trackItem) =>
                            trackItem.status === "MODIFIED_BY_CENTRAL_OPS"
                        );
                      const modifiedByBussinessHeadItem =
                        getAllThePayoutDetailsWithId.track.find(
                          (trackItem) =>
                            trackItem.status === "MODIFIED_BY_BUSINESS_HEAD"
                        );
    
                      if (
                        !modifiedByDSMItem &&
                        !modifiedByCentralOpsItem &&
                        !modifiedByBussinessHeadItem
                      ) {
                        return (
                          <>
                            <tr>
                              <th>Default Payout Amount</th>
                              <td>
                                {"Rs. " +
                                  getAllThePayoutDetailsWithId.final_payout_amount}
                              </td>
                            </tr>
                            <tr>
                              <th>Default Payout Percentage</th>
                              <td>
                                {getAllThePayoutDetailsWithId.final_payout_percentage +
                                  "%"}
                              </td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>{getAllThePayoutDetailsWithId.status}</td>
                            </tr>
                          </>
                        );
                      }
    
                      if (
                        defaultGeneratedItem &&
                        (modifiedByDSMItem ||
                          modifiedByCentralOpsItem ||
                          modifiedByBussinessHeadItem)
                      ) {
                        return (
                          <>
                            <tr>
                              <th>Default Payout Amount</th>
                              <td>
                                {"Rs. " + defaultGeneratedItem.payout_amount}
                              </td>
                            </tr>
                            <tr>
                              <th>Default Payout Percentage</th>
                              <td>
                                {defaultGeneratedItem.payout_percentage + "%"}
                              </td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>{getAllThePayoutDetailsWithId.status}</td>
                            </tr>
    
                            {modifiedByDSMItem && (
                              <>
                                <tr>
                                  <th>Payout Amount suggested by DSM</th>
                                  <td>
                                    {"Rs. " + modifiedByDSMItem.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Payout Percentage suggested by DSM</th>
                                  <td>
                                    {modifiedByDSMItem.payout_percentage + "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>DSM File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByDSMItem.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
    
                            {modifiedByCentralOpsItem && (
                              <>
                                <tr>
                                  <th>
                                    Payout Amount suggested by Central Ops
                                  </th>
                                  <td>
                                    {"Rs. " +
                                      modifiedByCentralOpsItem.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Payout Percentage suggested by Central Ops
                                  </th>
                                  <td>
                                    {modifiedByCentralOpsItem.payout_percentage +
                                      "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Central Ops File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByCentralOpsItem.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
                            {modifiedByBussinessHeadItem && (
                              <>
                                <tr>
                                  <th>
                                    Payout Amount suggested by Business Head
                                  </th>
                                  <td>
                                    {"Rs. " +
                                      modifiedByBussinessHeadItem?.payout_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Payout Percentage suggested by Business Head
                                  </th>
                                  <td>
                                    {modifiedByBussinessHeadItem?.payout_percentage +
                                      "%"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Business Head File</th>
                                  <td>
                                    <a
                                      href={
                                        modifiedByBussinessHeadItem?.payout_modification_proof_url
                                      }
                                      className="btn btn-primary btn-sm"
                                      target={"_blank"}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-download"></i>{" "}
                                      Download
                                    </a>
                                  </td>
                                </tr>
                              </>
                            )}
                            {getAllThePayoutDetailsWithId?.final_status ==
                              "PAYOUT_COMPLETED" && (
                              <tr>
                                <th>UTR No.</th>
                                <td>{getAllThePayoutDetailsWithId?.utr}</td>
                              </tr>
                            )}
                          </>
                        );
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
    
                {modificationRow && (
                  <>
                    <table className="table table-bordered mt-5 mr-4">
                      <tbody>
                        <tr>
                          <th>
                            Suggested Payout Amount
                            <span style={{ color: "red" }}>*</span>
                          </th>
                          <td>
                            <ConstantInput
                              errorMsg={localization.requiredCompanyName}
                              type="number"
                              value={inputList[0]?.modification_payout_amount}
                              handleChange={(val) => handleChange(val, 'modification_payout_amount')}
                              decimal={'decimal'}
                            />

                          </td>
                        </tr>
                        <tr>
                          <th>
                            Suggested Payout Percentage
                            <span style={{ color: "red" }}>*</span>
                          </th>
                          <td>
                          <ConstantInput
                            errorMsg={localization.requiredCompanyName}
                            type="number"
                            value={inputList[0]?.modification_payout_percentage}
                            handleChange={(val) => handleChange(val, 'modification_payout_percentage')}
                            decimal={'decimal'}
                          />
                          </td>
                        </tr>
                      </tbody>
                    </table>
    
                    <div className="col-md-4">
                      <FileUpload
                        id={"addAttachment"}
                        accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={handleFileUpload}
                      >
                        <span className="btn btn-transparent">
                          Upload Approval
                        </span>
                      </FileUpload>
                    </div>
    
                    {(getAllThePayoutDetailsWithId.status ==
                      "Accepted By Dsm" ||
                      getAllThePayoutDetailsWithId.status ==
                        "Modified By Dsm") && (
                      <Button
                        onClick={handleSubmit}
                        className="btn btn-primary  mt-4 mr-3"
                      >
                        Submit
                      </Button>
                    )}
                  </>
                )}
    
                {!modificationRow &&
                  (getAllThePayoutDetailsWithId.status == "Modified By Dsm" ||
                    getAllThePayoutDetailsWithId.status ==
                      "Accepted By Dsm") && (
                    <div className="d-flex mb-3 mb-3">
                      <Button
                        className="btn btn-sm btn-success mr-3"
                        onClick={handleAccept}
                      >
                        Accept
                      </Button>
                      <Button
                        className="btn btn-sm btn-warning"
                        onClick={handleModify}
                      >
                        Modify
                      </Button>
                    </div>
                  )}
              </div>
            </div>
          </div>
    
          <ModalPop
            title={localization.conf}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>Updated Successfully</h5>
              <Link to={`${baseUrl}/ucd/list`} className="btn btn-primary mb-4">
                Go to UCD List <img src={Images?.ArrowRight} alt="" />
              </Link>
            </div>
          </ModalPop>
        </Fragment>
      ) : (
        <Fragment>
          <div>
            <img src={Images?.NoData} alt="No data" width="100%" />
          </div>
        </Fragment>
      )}
    </Layout>
  );
};

export default PayoutDetails;
